// GraphQL Mutations - For direct use if needed
export const CREATE_CHANNEL = /* GraphQL */ `
    mutation CreateChannel(
        $name: String!
        $description: String!
        $type: String!
        $members: [String]!
        $referenceNo: String!
        $iconName: String
    ) {
        createChannel(
            name: $name
            description: $description
            type: $type
            members: $members
            referenceNo: $referenceNo
            iconName: $iconName
        ) {
            _id
            name
            description
            type
            members
            iconName
            referenceNo
            customer {
                name
                company
                email
                clientId
            }
            senderAvatar
            isExternal
            status
            priority
            createdAt
            updatedAt
            lastSenderId
            firstCustomerMessageAt
            firstAgentResponseAt
            lastCustomerMessageAt
            totalResponseTimeSeconds
            responseCount
        }
    }
`;

export const UPDATE_CHANNEL = /* GraphQL */ `
    mutation UpdateChannel(
        $channelId: ID!
        $name: String
        $status: String
        $priority: String
        $description: String
        $extraData: AWSJSON
        $senderAvatar: String
        $lastSenderId: String
        $internalNotes: AWSJSON
        $applicationStatus: String
    ) {
        updateChannel(
            channelId: $channelId
            name: $name
            status: $status
            priority: $priority
            description: $description
            extraData: $extraData
            senderAvatar: $senderAvatar
            lastSenderId: $lastSenderId
            internalNotes: $internalNotes
            applicationStatus: $applicationStatus
        ) {
            _id
            name
            description
            type
            members
            iconName
            referenceNo
            customer {
                name
                company
                email
                clientId
            }
            senderAvatar
            isExternal
            status
            priority
            priorityNote
            lastSenderId
            firstCustomerMessageAt
            firstAgentResponseAt
            lastCustomerMessageAt
            totalResponseTimeSeconds
            responseCount
            createdAt
            updatedAt
            internalNotes
            applicationStatus
        }
    }
`;

export const JOIN_CHANNEL = /* GraphQL */ `
    mutation JoinChannel($channelId: ID!) {
        joinChannel(channelId: $channelId) {
            _id
            name
            description
            type
            members
            iconName
            referenceNo
            customer {
                name
                company
                email
                clientId
            }
            senderAvatar
            isExternal
            status
            priority
            createdAt
            updatedAt
            lastSenderId
            firstCustomerMessageAt
            firstAgentResponseAt
            lastCustomerMessageAt
            totalResponseTimeSeconds
            responseCount
        }
    }
`;

export const ASSIGN_AGENT = /* GraphQL */ `
    mutation AssignAgent($channelId: ID!, $agentId: String!) {
        assignAgent(channelId: $channelId, agentId: $agentId) {
            _id
            name
            description
            type
            members
            iconName
            referenceNo
            extraData
            priority
            customer {
                name
                company
                email
                clientId
            }
            senderAvatar
            isExternal
            status
            createdAt
            updatedAt
            lastSenderId
            firstCustomerMessageAt
            firstAgentResponseAt
            lastCustomerMessageAt
            totalResponseTimeSeconds
            responseCount
        }
    }
`;

// memberIds must stay selected: the onNewMessage subscription filter only sees
// fields the publishing mutation selects, so without it agent replies never
// reach customers once filter_message_subscriptions is on.
export const SEND_MESSAGE = /* GraphQL */ `
    mutation SendMessage(
        $channelId: ID!
        $content: String
        $files: [String]
        $isFromBot: Boolean
        $sender: SenderInput!
    ) {
        sendMessage(
            channelId: $channelId
            content: $content
            files: $files
            isFromBot: $isFromBot
            sender: $sender
        ) {
            _id
            channelId
            content
            files
            isFromBot
            senderId
            sender {
                _id
                firstName
                lastName
                avatar
            }
            createdAt
            updatedAt
            memberIds
        }
    }
`;

export const MARK_CHANNEL_AS_READ = /* GraphQL */ `
    mutation MarkChannelAsRead($channelId: ID!, $userId: ID!, $lastReadMessageId: String!) {
        markChannelAsRead(
            channelId: $channelId
            userId: $userId
            lastReadMessageId: $lastReadMessageId
        ) {
            channelId
            userId
            lastReadMessageId
            unreadCount
            updatedAt
        }
    }
`;

export const INCREMENT_UNREAD_COUNT = /* GraphQL */ `
    mutation IncrementUnreadCount($channelId: ID!, $userId: ID!, $increment: Int!) {
        incrementUnreadCount(channelId: $channelId, userId: $userId, increment: $increment) {
            channelId
            userId
            lastReadMessageId
            unreadCount
            updatedAt
        }
    }
`;

export const DECREMENT_UNREAD_COUNT = /* GraphQL */ `
    mutation DecrementUnreadCount($channelId: ID!, $userId: ID!, $decrement: Int!) {
        decrementUnreadCount(channelId: $channelId, userId: $userId, decrement: $decrement) {
            channelId
            userId
            lastReadMessageId
            unreadCount
            updatedAt
        }
    }
`;

export const RESET_UNREAD_COUNT = /* GraphQL */ `
    mutation ResetUnreadCount($channelId: ID!, $userId: ID!) {
        resetUnreadCount(channelId: $channelId, userId: $userId) {
            channelId
            userId
            lastReadMessageId
            unreadCount
            updatedAt
        }
    }
`;
